/* eslint-disable @typescript-eslint/no-explicit-any */
export function debounce(func: any, timeout = 100) {
  let timer: any;

  return function (...args: any[]) {
    clearTimeout(timer);

    const self = this as any;

    timer = setTimeout(function () {
      func.apply(self, args);
    }, timeout);
  };
}
